export default __webpack_public_path__ + "static/char-s-12-chs-dc968775cf3ffa72ac5802efd441c96f.webp";